<template>
  <div id="container"></div>
</template>

<script>
// 文档说明：https://lbs.baidu.com/index.php?title=jspopularGL
import { debounce } from '@/utils/dataUtil';
// import customMapConfig from '@/assets/mapStyles/custom_map_config.json';

export default {
  name: 'DtCarMap',
  props: {
    cityId: {
      type: Number,
      required: true,
    },
    hospitalCode: {
      type: String,
      default: () => '',
    },
    diyCarNo: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      // BMAP_NORMAL_MAP: 普通街道视图,
      // BMAP_SATELLITE_MAP: 卫星视图,
      // BMAP_HYBRID_MAP: 卫星和路网的混合视图
      mapType: window.BMAP_NORMAL_MAP,
      // mapType: window.BMAP_SATELLITE_MAP,
      // 千米，没给后台默认为100KM
      distance: 500,
      // 初始经度
      // 拾取坐标系统  http://api.map.baidu.com/lbsapi/getpoint/index.html
      initLng: 114.271443,
      // 初始纬度
      initLat: 30.503821,
      // 已经标注的集合
      markerArr: [],
      map: null,
      // 是否根据地图上的点位动态调整中心点及缩放范围
      dynamicChangeCenterAndZoom: true,
      // 添加路线相关数据
      drivingRoute: null,
      routePoints: [],
      currentRouteIndex: 0,
      routeAnimationTimer: null,
      // 实时轨迹相关
      realTimePolyline: null,
      trackedCar: null,
      trackedCarMarker: null,
    };
  },
  mounted() {
    let self = this;
    self.resetCenterLbsByCityId();
    let { BMapGL } = window;
    console.log('%c%s', 'color:blue', 'CarMap.vue mounted');
    console.log('diyCarNo:', this.diyCarNo);
    self.map = new BMapGL.Map('container');
    self.map.setMapType(self.mapType);
    self.map.enableScrollWheelZoom();

    // // 针对hospitalCode=054H002的，不要自定义地图样式
    // if (this.hospitalCode !== '054H002') {
    //   self.map.setMapStyleV2({
    //     styleJson: customMapConfig,
    //   });
    // }
    self.initCenterAndRoom(self.map, self.initLng, self.initLat);
    self.startLoop();
    self.map.addEventListener('dragend',
      debounce(() => {
        self.moveHandler();
      }, 500));
  },
  methods: {

    /**
     * 根据城市设置中心位置
     * 坐标需要增量更新,获取地址：http://api.map.baidu.com/lbsapi/getpoint/index.html
     */
    resetCenterLbsByCityId() {
      let self = this;
      const lbsMap = {
        '6': {
          'name': '邯郸',
          'lng': '114.542278',
          'lat': '36.626829',
        },
        '169': {
          'name': '武汉',
          'lng': '114.268072',
          'lat': '30.619868',
        },
        '7': {
          'name': '清河',
          'lng': '115.68382',
          'lat': '37.069178',
        },
        '172': {
          'name': '兴山',
          'lng': '110.76',
          'lat': '31.34',
        },
      };
      let lbsInfo = lbsMap[`${this.cityId}`];
      if (lbsInfo) {
        self.initLng = lbsInfo.lng;
        self.initLat = lbsInfo.lat;
      }
      // eslint-disable-next-line eqeqeq
      if (this.cityId == 7) {
        this.dynamicChangeCenterAndZoom = false;
        console.log('清河，不根据地图上的点位动态调整中心点及缩放范围');
      }
      console.log(`当前城市${this.cityId}的初始经度initLng:${self.initLng},初始维度initLat:${self.initLat}`);
    },

    /**
     * 地图拖动事件
     *
     * 这种事件，不用自动设置当前地图中心点
     */
    moveHandler() {
      let self = this;
      console.log('处理地图拖动方法');
      console.log('self.map', self.map);
      // 获取可视区域中心点坐标
      const center = self.map.getCenter();
      console.log(center.lng, center.lat);
      // 动态改变中心点
      self.initLng = center.lng;
      self.initLat = center.lat;
      // 重新获取当前视野中的数据
      self.getLbsData(false, {});
    },

    /**
     * 循环执行获取经纬度信息
     * 生命周期退出时清理定时任务
     */
    startLoop() {
      let self = this;
      // self.getMockLbsData();
      self.getLbsData(true, { lastLoopLng: self.initLng, lastLoopLat: self.initLat });

      // 初步执行时，保存当前的中心点，当定时任务返回时，判断中心点是否有变，有变，说明有拖动，放弃本次请求内容
      let timer = setInterval(() => {
        // self.getMockLbsData();
        self.getLbsData(true, { lastLoopLng: self.initLng, lastLoopLat: self.initLat });
      }, 10000);

      this.$once('hook:beforeDestory', () => {
        clearInterval(timer);
        timer = null;
      });
    },

    /**
     * 获取车辆位置数据
     * @param isSetCenterAndZoom  是否需要重新定位中心点及缩放级别
     */
    getLbsData(isSetCenterAndZoom, closureLbs) {
      let self = this;
      console.log('%c%s', 'color:blue', `getLbsData,isSetCenterAndZoom:${isSetCenterAndZoom},\ninitLng:${self.initLng},initLat:${self.initLat},\nlastLoopLng:${closureLbs.lastLoopLng}, lastLoopLat:${closureLbs.lastLoopLat}`);
      // const param = {
      //   distance: self.distance,
      //   lng: self.initLng,
      //   lat: self.initLat,
      //   cityId: self.cityId,
      // };

      // this.$axios.post('/api/apvehicle/car/position/allCarLbs', param, {}).then((response) => {
      this.$axios.get(`/api/apvehicle/car/position/getCarPositionByHospital?hospitalCode=${this.hospitalCode}`).then((response) => {
        let { data } = response;
        // if (data.msg === 201 && data.respData && Array.isArray(data.respData) && data.respData.length > 0) {
        //   let arr = [{ ...data.respData[0], carNo: self.carNo }];
        //   console.log('arr:', arr);
        //   // let arr =[{lng: 114.541231, lat: 30.481718, carNo: '鄂A00001', rotation: 30},
        //   //       {lng: 114.541833, lat: 30.480652, carNo: '鄂A00002', rotation: 77},
        //   //       {lng: 114.537306, lat: 30.482115, carNo: '鄂A00003', rotation: 106},
        //   //       {lng: 114.534063, lat: 30.486737, carNo: '鄂A00004', rotation: 190},
        //   //       {lng: 114.306872, lat: 30.75472, carNo: '鄂A00005', rotation: 190},
        //   //       {lng: 114.23817, lat: 30.753975, carNo: '鄂A00006', rotation: 190},
        //   //       {lng: 113.986213, lat: 30.488946, carNo: '鄂A00007', rotation: 190},
        //   //     ];
        //   self.clearAllMarker(self.map);
        //   self.addOrReplaceAllMarkers(arr, self.map);
        // }

        if (data.msg === 201 && data.respData) {
          console.log(data.respData);

          const newArr = [];

          // for (let key in data.respData) {
          //   data.respData[key] && data.respData[key].forEach((car) => {
          //     newArr.push({
          //       carNo: key,
          //       lng: car.lng,
          //       lat: car.lat,
          //       state: car.state,
          //       distancs: car.distancs,
          //       lbsJson: car.lbsJson,
          //     });
          //   });
          // }

          Object.keys(data.respData).forEach((key) => {
            const carList = data.respData[key];
            if (Array.isArray(carList)) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < carList.length; i++) {
                const car = carList[i];
                if (self.diyCarNo && self.diyCarNo !== '' && self.diyCarNo !== key) {
                  // eslint-disable-next-line no-continue
                  continue;
                }
                newArr.push({
                  carNo: key,
                  lng: car.lng,
                  lat: car.lat,
                  state: car.state,
                  distancs: car.distancs,
                  lbsJson: car.lbsJson,
                });
              }
            }
          });

          // let { lbs, centerPoint } = data.respData;
          // let newArr = lbs.map(({
          //   carNo, lng, lat, state, distancs, lbsJson,
          // }) => ({
          //   carNo, lng, lat, state, distancs, lbsJson,
          // }));

          if (isSetCenterAndZoom) {
            // 说明轮询这段时间内，没有做拖动等改变中心点的动作
            if (self.initLng && self.initLat) {
              console.log('%c%s', 'color:green', '定时任务：需重置定位中心点');
              self.clearAllMarker(self.map);
              self.addOrReplaceAllMarkers(newArr, self.map, isSetCenterAndZoom);
            } else {
              console.log('%c%s', 'color:green', '定时任务：轮询时，有改变中心点操作，本次结果不做处理');
            }
          } else {
            // 拖动操作使用
            console.log('%c%s', 'color:green', '拖动：不需重置定位中心点');
            self.clearAllMarker(self.map);
            self.addOrReplaceAllMarkers(newArr, self.map, false);
          }

          // // 更新实时轨迹
          // self.updateRealTimeTrack(newArr);
        }
      });
    },

    getMockLbsData() {
      let self = this;
      let arr = [{
        lng: 114.541231, lat: 30.481718, carNo: '鄂A00001', rotation: 30,
      },
      {
        lng: 114.541833, lat: 30.480652, carNo: '鄂A00002', rotation: 77,
      },
      {
        lng: 114.537306, lat: 30.482115, carNo: '鄂A00003', rotation: 106,
      },
      {
        lng: 114.534063, lat: 30.486737, carNo: '鄂A00004', rotation: 190,
      },
      {
        lng: 114.306872, lat: 30.75472, carNo: '鄂A00005', rotation: 190,
      },
      {
        lng: 114.23817, lat: 30.753975, carNo: '鄂A00006', rotation: 190,
      },
      {
        lng: 113.986213, lat: 30.488946, carNo: '鄂A00007', rotation: 190,
      },
      ];
      self.clearAllMarker(self.map);
      self.addOrReplaceAllMarkers(arr, self.map);
    },

    /**
     * 初始化时设置地图中心点和缩放范围
     * @param map
     * @param lng
     * @param lat
     */
    initCenterAndRoom(map, lng, lat) {
      let { BMapGL } = window;
      var point = new BMapGL.Point(lng, lat);
      // 设初始化地图。 如果center类型为Point时，zoom必须赋值，范围3-19级，若调用高清底图（针对移动端开发）时，
      // zoom可赋值范围为3-18级。如果center类型为字符串时，比如“北京”，zoom可以忽略，地图将自动根据center适配最佳zoom级别
      map.centerAndZoom(point, 13);
    },

    /**
     * 设置标记物动画
     *
     * @param marker
     */
    setAnimation(marker) {
      let { BMAP_ANIMATION_BOUNCE } = window;
      // 添加延时确保标记已经添加到地图上
      setTimeout(() => {
        if (marker && typeof marker.setAnimation === 'function') {
          marker.setAnimation(BMAP_ANIMATION_BOUNCE);
        }
      }, 100);
    },

    /**
     * 新增和替换标注
     * @param lbsList
     * @param map
     * @param isSetCenterAndZoom
     */
    addOrReplaceAllMarkers(lbsList, map, isSetCenterAndZoom) {
      const self = this;
      const { BMapGL } = window;
      const bounds = this.getBounds(map);
      const viewPoints = [];
      console.log('addOrReplaceAllMarkers,lbsList:', lbsList);
      lbsList.forEach((item) => {
        console.log('item.lng', item.lng);
        console.log('item.lat', item.lat);
        const content = item.carNo;
        const existMarker = self.findMarker(self.markerArr, content);
        if (existMarker) {
          const mk = self.replaceMarkerIfNeed(map, existMarker, item.lng, item.lat, content);
          if (mk) {
            let ep = mk.getPosition();
            viewPoints.push(ep);
            let isContains = self.containsPoint(bounds, ep);
            console.log(`当前坐标lng:${item.lng},lat:${item.lat}是否在可视范围内:${isContains}`);
            if (!isContains) {
              self.extend(bounds, ep);
            }
            // 为已存在的标记添加动画效果
            self.setAnimation(mk);
          }
        } else {
          // 全新的待标注点
          const point = new BMapGL.Point(item.lng, item.lat);
          let isContains = self.containsPoint(bounds, point);
          console.log(`当前坐标lng:${item.lng},lat:${item.lat}是否在可视范围内:${isContains}`);
          if (!isContains) {
            self.extend(bounds, point);
          }
          viewPoints.push(point);
          const marker = self.createMarker(point, content);

          // 将覆盖物添加到地图中，一个覆盖物实例只能向地图中添加一次
          map.addOverlay(marker);
          self.setAnimation(marker);
        }
      });
      console.log('viewPoints:', viewPoints);
      if (isSetCenterAndZoom) {
        self.setCenterAndZoom(map, viewPoints);
      }
    },

    /**
     * 清理所有标注物
     *
     * @param map
     */
    clearAllMarker(map) {
      for (let i = 0; i < this.markerArr.length; i++) {
        map.removeOverlay(this.markerArr[i]);
      }
      this.markerArr.length = 0;
    },

    /**
     * 查找相同标签名称的标注，经纬度可能不同
     * @param markerList
     * @param content
     */
    findMarker(markerList, content) {
      let marker = markerList.find((item) => item.getLabel() == content);
      return marker;
    },

    /**
     * 逻辑上判断是否为同一个标注物
     *
     * @param marker
     * @param lng
     * @param lat
     * @param content
     * @returns {boolean}
     */
    isSameMarker(marker, lng, lat, content) {
      console.log(`isSameMarker,lng:${lng},lat:${lat},content:${content}`);
      let { lng: ptLng, lat: ptLat } = marker.getPosition();
      let { content: mkContent } = marker.getLabel();
      console.log(`isSameMarker,ptLng:${ptLng},ptLat:${ptLat},mkContent:${mkContent}`);
      return lng == ptLng && lat == ptLat && content == mkContent;
    },

    /**
     * 当经纬度不一样，标注内容一样时，为需要更新的marker
     *
     * @param marker
     * @param lng
     * @param lat
     * @param content 相同就认为需要一样
     * @returns {boolean}
     */
    needUpdateMarker(marker, lng, lat, content) {
      console.log(`needUpdateMarker,lng:${lng},lat:${lat},content:${content}`);
      let { lng: ptLng, lat: ptLat } = marker.getPosition();
      let { content: mkContent } = marker.getLabel();
      console.log(`needUpdateMarker,ptLng:${ptLng},ptLat:${ptLat},mkContent:${mkContent}`);
      return (!(lng == ptLng && lat == ptLat)) && content == mkContent;
    },

    /**
     * 创建一个图像标注
     *
     * https://mapopen-pub-jsapi.bj.bcebos.com/jsapi/reference/jsapi_reference_3_0.html#a3b2
     *
     * @param point
     * @param content 当前传输的为车牌号
     * @returns {Marker}
     */
    createMarker(point, content) {
      let { BMapGL } = window;
      let marker = new BMapGL.Marker(point, {
        icon: new BMapGL.Icon('/map/image/img_car@2x.png', new BMapGL.Size(80, 80),
          { anchor: new BMapGL.Size(27, 13) }),
      });

      // https://mapopen-pub-jsapi.bj.bcebos.com/jsapi/reference/jsapi_reference_3_0.html#a3b9
      var label = new BMapGL.Label(content,
        {
          offset: new BMapGL.Size(0, -33),
          enableClicking: true,
        });
      label.setStyle({
        border: 'none',
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '18px',
        borderRadius: '2px',
        padding: '2px 6px',
        background: 'linear-gradient( 90deg, #00ABF4 0%, #1C61F4 100%)',
        width: '71px',
        height: '22px',
        boxShadow: '0px 4px 6px 0px rgba(0,45,132,0.2)',
      });
      // 监听标注的点击事件
      label.addEventListener('click', (e) => {
        console.log('标注被点击了', e);
        console.log(`当前点击label内容:${e.currentTarget.content}`);
        // TODO 这里可以添加获取当前车辆的视频信息
      });
      marker.setLabel(label);
      this.markerArr.push(marker);
      return marker;
    },

    /**
     * 当content相同，经纬度不同时，替换地图上已经存在的marker，其他情况不处理
     *
     * @param map
     * @param marker 地图上已经存在的标注
     * @param lng
     * @param lat
     * @param content
     */
    replaceMarkerIfNeed(map, marker, lng, lat, content) {
      const {
        isSameMarker, needUpdateMarker, createMarker, setAnimation,
      } = this;
      const { BMapGL } = window;
      const point = new BMapGL.Point(lng, lat);

      if (!isSameMarker(marker, lng, lat, content)) {
        // 标签一样，但经纬度不相同时
        if (needUpdateMarker(marker, lng, lat, content)) {
          map.removeOverlay(marker);
          const updateMarker = createMarker(point, content);
          map.addOverlay(updateMarker);
          setAnimation(updateMarker);
          // markerArr中替换原来的
          const filteredArr = this.markerArr.filter((item) => item.getLabel() != content);
          filteredArr.push(updateMarker);
          this.markerArr = { ...filteredArr };
          return updateMarker;
        }
        return null;
      }

      console.log(`相同，不作替换,lng:${lng},lat:${lat},content:${content}`);
      return marker;
    },

    /**
     * 返回地图可视区域，以地理坐标表示
     * @param map
     * @returns {*}
     */
    getBounds(map) {
      let bounds = map.getBounds();
      console.log('当前地图的可视范围bounds:', bounds);
      return bounds;
    },

    /**
     * 如果点的地理坐标位于此矩形内，则返回true
     * @param bounds
     * @param point
     */
    containsPoint(bounds, point) {
      let isContains = bounds.containsPoint(point);
      return isContains;
    },

    /**
     * 放大此矩形，使其包含给定的点
     *
     * @param bounds
     * @param point
     */
    extend(bounds, point) {
      bounds.extend(point);
    },

    /**
     * 重新设置地图，恢复地图初始化时的中心点和级别
     *
     * @returns {*}
     */
    reset(map) {
      map.reset();
    },
    /**
     * 返回地图当前中心点
     * @param map
     * @returns {*}
     */
    getCenter(map) {
      let center = map.getCenter();
      console.log('center:', center);
      return center;
    },
    /**
     * 返回地图当前缩放级别
     * @param map
     * @returns {*}
     */
    getZoom(map) {
      let zoom = map.getZoom()();
      console.log('zoom:', zoom);
      return zoom;
    },
    /**
     * 将视图切换到指定的缩放等级，中心点坐标不变。注意：当有信息窗口在地图上打开时，地图缩放将保证信息窗口所在的坐标位置不动
     * @param map
     * @param zoom Number
     */
    setZoom(map, zoom) {
      map.setZoom(zoom);
    },

    /**
     * 调整地图的中心点和缩放级别
     * 自动轮询的才会调整，拖动的不会主动调整
     *
     * @param map
     * @param view Array<Point>
     */
    setCenterAndZoom(map, viewPoints) {
      if (!this.dynamicChangeCenterAndZoom) {
        return;
      }
      let view = map.getViewport(viewPoints);
      let mapZoom = view.zoom;
      let centerPoint = view.center;
      map.centerAndZoom(centerPoint, mapZoom);
      this.initLng = centerPoint.lng;
      this.initLat = centerPoint.lat;
    },

    /**
     * 根据提供的地理区域或坐标获得最佳的地图视野，返回的对象中包含center和zoom属性，分别表示地图的中心点和级别。
     * 此方法仅返回视野信息，不会将新的中心点和级别做用到当前地图上
     *
     * @param view : Array<Point>
     * @param viewportOptions : ViewportOptions
     * @returns {*}
     */
    getViewport(map, view, viewportOptions) {
      let viewport = map.getViewport(view, viewportOptions);
      console.log('viewport:', viewport);
      return viewport;
    },

    /**
     *
     * 根据提供的地理区域或坐标设置地图视野，调整后的视野会保证包含提供的地理区域或坐标
     *
     * @param map
     * @param view Array<Point> | Viewport
     * @param viewportOptions ViewportOptions
     */
    setViewport(map, view, viewportOptions) {
      map.setViewport(view, viewportOptions);
    },

    /**
     *  将地图的中心点更改为给定的点。如果该点在当前的地图视图中已经可见，则会以平滑动画的方式移动到中心点位置。
     *  可以通过配置强制移动过程不使用动画效果
     *
     * @param center Point
     * @param opts PanOptions
     */
    panTo(map, center, opts) {
      map.panTo(center, opts);
    },

    /**
     * 计算两点间的路线
     * @param startPoint 起点坐标{lng, lat}
     * @param endPoint 终点坐标{lng, lat}
     */
    calculateRoute(startPoint, endPoint) {
      const { BMapGL } = window;
      const start = new BMapGL.Point(startPoint.lng, startPoint.lat);
      const end = new BMapGL.Point(endPoint.lng, endPoint.lat);

      // 创建驾车路线实例
      this.drivingRoute = new BMapGL.DrivingRoute(this.map, {
        renderOptions: {
          map: this.map,
          autoViewport: true,
          strokeColor: '#0066ff',
          strokeWeight: 6,
        },
        onSearchComplete: (results) => {
          if (this.drivingRoute.getStatus() == window.BMAP_STATUS_SUCCESS) {
            // 获取路线上的关键点
            const plan = results.getPlan(0);
            const route = plan.getRoute(0);
            const paths = route.getPath();

            // 保存路线点
            this.routePoints = paths;
            this.currentRouteIndex = 0;

            console.log('路线计算完成，共有', paths.length, '个路径点');
          }
        },
      });

      // 发起路线搜索
      this.drivingRoute.search(start, end);
    },

    /**
     * 开始路线动画
     * @param marker 需要沿路线移动的标记
     */
    startRouteAnimation(marker) {
      if (!this.routePoints || this.routePoints.length === 0) {
        console.warn('没有可用的路线点');
        return;
      }

      // 清除之前的动画
      if (this.routeAnimationTimer) {
        clearInterval(this.routeAnimationTimer);
      }

      // 每100ms移动一次
      this.routeAnimationTimer = setInterval(() => {
        if (this.currentRouteIndex < this.routePoints.length) {
          const point = this.routePoints[this.currentRouteIndex];
          marker.setPosition(point);
          this.currentRouteIndex += 1;
        } else {
          // 动画结束，清除定时器
          clearInterval(this.routeAnimationTimer);
          this.routeAnimationTimer = null;
        }
      }, 100);
    },

    /**
     * 更新实时轨迹
     * @param carList 车辆列表
     */
    updateRealTimeTrack(carList) {
      // 如果没有需要追踪的车辆，直接返回
      if (!this.trackedCar || carList.length === 0) {
        return;
      }

      // 查找被追踪的车辆
      const trackedCarData = carList.find((car) => car.carNo === this.trackedCar.carNo);

      if (trackedCarData) {
        const { BMapGL } = window;
        const currentPoint = new BMapGL.Point(trackedCarData.lng, trackedCarData.lat);

        // 如果还没有创建实时轨迹线，则创建一个
        if (!this.realTimePolyline) {
          this.realTimePolyline = new BMapGL.Polyline([currentPoint], {
            strokeColor: '#ff0000',
            strokeWeight: 4,
            strokeOpacity: 0.8,
          });
          this.map.addOverlay(this.realTimePolyline);
        } else {
          // 更新轨迹线，添加新的点
          const path = this.realTimePolyline.getPath();
          path.push(currentPoint);
          this.realTimePolyline.setPath(path);
        }

        // 更新车辆标记位置
        if (this.trackedCarMarker) {
          this.trackedCarMarker.setPosition(currentPoint);
        }
      }
    },

    /**
     * 开始追踪指定车辆
     * @param car 车辆信息{carNo, lng, lat}
     */
    startTrackingCar(car) {
      const { BMapGL } = window;

      // 设置当前追踪的车辆
      this.trackedCar = car;

      // 创建或更新车辆标记
      const carPoint = new BMapGL.Point(car.lng, car.lat);

      if (!this.trackedCarMarker) {
        this.trackedCarMarker = this.createMarker(carPoint, `${car.carNo}(追踪中)`);
        this.map.addOverlay(this.trackedCarMarker);
      } else {
        this.trackedCarMarker.setPosition(carPoint);
      }

      // 清除之前的实时轨迹线
      if (this.realTimePolyline) {
        this.map.removeOverlay(this.realTimePolyline);
      }

      // 创建新的实时轨迹线
      this.realTimePolyline = new BMapGL.Polyline([carPoint], {
        strokeColor: '#ff0000',
        strokeWeight: 4,
        strokeOpacity: 0.8,
      });
      this.map.addOverlay(this.realTimePolyline);

      console.log(`开始追踪车辆: ${car.carNo}`);
    },

    /**
     * 停止追踪车辆
     */
    stopTrackingCar() {
      // 清除追踪的车辆
      this.trackedCar = null;

      // 移除车辆标记
      if (this.trackedCarMarker) {
        this.map.removeOverlay(this.trackedCarMarker);
        this.trackedCarMarker = null;
      }

      // 移除实时轨迹线
      if (this.realTimePolyline) {
        this.map.removeOverlay(this.realTimePolyline);
        this.realTimePolyline = null;
      }

      console.log('停止追踪车辆');
    },

  },

  // 添加销毁时清理定时器
  beforeDestroy() {
    if (this.routeAnimationTimer) {
      clearInterval(this.routeAnimationTimer);
      this.routeAnimationTimer = null;
    }
  },
};
</script>
<style>
/*去除地图下方的标标注*/
.anchorBL a,
.anchorBL img,
.anchorBL span {
  display: none !important;
}
</style>

<style lang="scss" scoped>
#container {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
</style>

<style lang="scss">
.map .mapBGFault {
  width: 50px;
  height: 50px;
  background: red;
  border-radius: 25px;
  transform: scale(0);
  animation: myfirst 2s;
  animation-iteration-count: infinite;
}

@keyframes myfirst {
  to {
    background: rgba(0, 0, 0, 0);
    transform: scale(2);
  }
}
</style>
